import React, { useState, useEffect } from "react";
import { Link, NavLink, useNavigate, useLocation } from 'react-router-dom';
import './../../styles/admin/Sidebar.css';
import Logo from './../../components/logo.png'
import * as globals from './../../components/GlobalScripts.js';

const Sidebar = () => {
    let path_api = localStorage.getItem('path_api');
    const navigate = useNavigate();
    const location = useLocation();
    const [user, setUser] = useState([]);
    const [isMenuOpenConf, setMenuIsOpenConf] = useState(false);

    useEffect(() => {
        if (globals.isAuthenticated()) {
            globals.validateSession();
        }
        setMenuIsOpenConf(false);
    }, [location]);

    useEffect(() => {
        const user_cache = localStorage.getItem('user');
        if (user_cache) {
            setUser(JSON.parse(user_cache));
        }
    }, []);

    const handleLogout = async (e) => {
        e.preventDefault();
        localStorage.removeItem('session_id');
        localStorage.removeItem('keylogin');
        localStorage.removeItem('code_confirm');
        localStorage.removeItem('user');

        navigate(`/login`);
    };

    const handleOpenConf = () => {
        setMenuIsOpenConf(!isMenuOpenConf);
    };

    return (
        <div className="sidebar">
            <div className='logo-container'>
                <Link to="/admin/cuentas">
                    <img className='logo' src={Logo} alt='Logo' />
                </Link>
            </div>
            <div className="container-profile-navbar" onClick={handleOpenConf}>
                <p><b>{user?.nombre + ' ' + user?.account?.apellidos}</b></p>
                <svg width="15" className={isMenuOpenConf ? "is-open" : ""} viewBox="0 0 74 47" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M32.2938 44.625L2.31875 10.3625C-1.21875 6.33125 1.65625 -1.51654e-06 7.025 -1.51654e-06H66.975C68.1765 -0.00103169 69.3529 0.344295 70.3632 0.994627C71.3735 1.64496 72.175 2.57273 72.6716 3.66683C73.1682 4.76093 73.3389 5.97499 73.1632 7.16361C72.9876 8.35223 72.4731 9.46503 71.6813 10.3687L41.7063 44.6187C41.1196 45.2901 40.3962 45.8281 39.5844 46.1967C38.7727 46.5654 37.8915 46.7561 37 46.7561C36.1085 46.7561 35.2273 46.5654 34.4156 46.1967C33.6038 45.8281 32.8804 45.2901 32.2938 44.6187V44.625Z" fill="black" />
                </svg>
                {isMenuOpenConf && (
                    <div className="menu-conf">
                        {/* <NavLink to="/admin/cuenta">Mi cuenta</NavLink> */}
                        <Link onClick={handleLogout}>Cerrar sesión</Link>
                    </div>
                )}
            </div>
            <ul className="margin-top">
                <li>
                    <NavLink to="/chat/view">Conversaciones</NavLink>
                </li>
                <li>
                    <NavLink to="/admin/cuentas">Cuentas</NavLink>
                </li>
                <li>
                    <NavLink to="/admin/mensajes">Mensajes</NavLink>
                </li>
                <li>
                    <NavLink to="/admin/reviews">Reseñas</NavLink>
                </li>
                <li>
                    <NavLink to="/admin/pagos-de-clientes">Pagos de clientes</NavLink>
                </li>
                {/* <li>
                    <NavLink to="/admin/pagos-a-profesionales">Pagos a profesionales</NavLink>
                </li> */}
                <li>
                    <NavLink to="/admin/reportes">Reportes</NavLink>
                </li>
                <li>
                    <NavLink to="/admin/categorias">Categorias</NavLink>
                </li>
            </ul>
        </div>
    );
};

export default Sidebar;